

    import React,{Component} from 'react';
	// import Nav from './nav';
	// import About from './aboutUs';
	// import Contact from './contact';
	// import View from './viewer';
	// //import Btn from './button';
	import {Link} from 'react-router-dom';
	import axios from "axios";
	
	 
	class register extends Component{
		
		constructor(props)
		{
			super(props)
			
			this.state = {
				email: null,
				password: null,
				tokenPresence: false,
				loading:false
			}

            this.submitHandler = this.submitHandler.bind(this);
            this.handleEmail = this.handleEmail.bind(this);
            this.handlePassword = this.handlePassword.bind(this);

		}
	
        
        
        componentDidMount()
        {
			
            //check for token and redirect to dashboard
			let accessToken = localStorage.getItem("token");
			if(accessToken !== "noToken")
			{
				if(accessToken !== null)
				{
				// alert(accessToken);
					this.setState({tokenPresence:true});
					
				}
				
			}
			


			if(accessToken !== null)
			{
				if(accessToken !== "noToken")
				{
				// alert(accessToken);
					this.setState({tokenPresence:true});
					
				}
				
			}
			
		
			if((accessToken !== null) && (accessToken !== "noToken") && (this.state.tokenPresence === true))
			{   //redirect to home dashboard
				this.props.history.push('/gitsearch/dashboard');
			}
        }

        componentDidUpdate()
        {
           // alert("componentDidUpdate");
        }

        

       async submitHandler(e)
        {
			e.preventDefault();
			this.setState({loading:true});
			if((this.state.email !== null) && (this.state.password !== null) && (this.state.email !== "") && (this.state.password !== ""))
			{
				//make axios call
				try{
                    let response  =  await axios.post("http://mofehintolumumuni.com/gitserver/api/register",{
                        email: this.state.email,
                        password: this.state.password
                    });

                    let status = response.data.status;
					let token = response.data.token;
					let message = response.data.message;
					let VerifyMailSentStatus = response.data.VerifyMailSentStatus;
					
                  
                    if(status === "success"){
             
				  localStorage.setItem("token",token);
				  
				(VerifyMailSentStatus) ? alert("Registration successful an email verification link has been sent to your mail") : alert("Registration successful click resend email verification in your dashboard area to resend email verification mail");
				  
				  //redirect to dashboard
                  this.props.history.push("/gitsearch/dashboard");
                     }else{
						this.setState({loading:false});
				
						 alert(`Registration not successful ${message}`);
                     } 
             
                    
            }
            catch(error){
				this.setState({loading:false});
				alert(`Registration not successful`);
            }
			}
			else
			{this.setState({loading:false});
				alert("Please fill form properly before submitting");
			}
        }

        handleEmail(e)
        {
            let formInput = e.target.value;
            this.setState({"email": formInput});
        }

		handlePassword(e)
        {
            let formInput = e.target.value;
            this.setState({"password": formInput});
        }



	render()
	{
	return(
	
		<React.Fragment>
		<section>
		
	<div id="page-wrapper" className="sign-in-wrapper">
				<div className="graphs">
					<div className="sign-in-form">
						<div className="sign-in-form-top">
							<h1 >Register <i className="fa fa-chevron-circle-right"></i></h1>
							<p>Password must contain letters or a combination of letters and digits only</p>
							{(this.state.loading) ? <h3>Loading <i className="fa fa-cogs" ></i> </h3> : null}
						</div>
						<div className="signin">
						
						<form onSubmit={this.submitHandler}>
							<div className="log-input">
								<div className="log-input-left">
								   <input type="text" name="postemail" className="user" onChange={this.handleEmail} placeholder="Enter Email"  />
								</div>
								
								<div className="clearfix"> </div>
							</div>
							<div className="log-input">
								<div className="log-input-left">
								   <input type="password" name="postpassw" className="lock" onChange={this.handlePassword} placeholder="Enter Password"  />
								</div>
								
								<div className="clearfix"> </div>
							</div>
							<input id="logi" type="submit" name="send" value="Register" />
						</form>	
						
							<div className="signin-rit">
							<form name="myform" action="" method="post">
								<span className="checkbox1">
									<Link to="/gitsearch/forgotPassword" > <label className="checkbox" >Forgot Password?</label></Link>
								</span>
								
								<div className="clearfix"> </div>
								</form>


						</div>
						</div>
						<div className="new_people">
							<h2>Have an account on gitSearch?</h2>
							<p></p>
							<Link to="/gitsearch/login">Login Now!</Link>
						</div>
					</div>
				</div>
			</div>
			</section>
</React.Fragment>

	);
	}


    }
    



    export default register;


